// extracted by mini-css-extract-plugin
export default {"plans":"style_plans__xTPzD"};